import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Assignment from "@material-ui/icons/Assignment";
import * as React from "react";
import { RouterProps } from "react-router";
import { IProperAccessCodeResponse, ResponseSource } from "src/services";
import Component from "../../components/Component";
import MobilePage from "../../components/MobilePage";
import withAxios, { IAxiosProps } from "../../components/withAxios";

const styles = (theme: Theme) => ({});

interface IEnterCodePageProps {
  responseSource: number;
  schoolData:any; // TODO: Define the type for schoolData
}

type IProps = IEnterCodePageProps &
  RouterProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface IInputInformationState {
  code: string;
  checkingCode?: true;
}

export default withStyles(styles)(
  withAxios(
    class EnterCodePage extends Component<IProps, IInputInformationState> {
      public readonly state = this.buildState({
        code: "",
      });

      private readonly handleCodeChange = this.stateInputEventHandler((v) => ({
        code: v,
      }));

      // render for both students and coaches
      public render() {
        const { responseSource } = this.props;

        switch (responseSource) {
          case ResponseSource.student:
            return (
              <MobilePage
                header={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "Coach"
                    : "Student"
                }
                title={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "Coach Code Input"
                    : "Student Code Input"
                }
                subtitle=""
                schoolLogo=""
                schoolLogo2=""
                headerIcon={<Assignment />}
                tagline={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "Go Coaches!"
                    : "Go Students!"
                }
              >
                {this.renderForm()}
              </MobilePage>
            );
          case ResponseSource.coach:
            return (
              <MobilePage
                header={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "AD"
                    : "Coach"
                }
                title={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "AD Code Input"
                    : "Coach Code Input"
                }
                subtitle={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "Self-survey is imperative for great ADs."
                    : "Self-survey is imperative for great leaders."
                }
                schoolLogo=""
                schoolLogo2=""
                headerIcon={<Assignment />}
                tagline={
                  this.props?.schoolData?.isAdSurvey === true
                    ? "Go ADs!"
                    : "Go Coaches!"
                }
              >
                {this.renderForm()}
              </MobilePage>
            );
          default:
            return <span>Something is wrong</span>;
        }
      }

      private renderForm() {
        const { code, checkingCode } = this.state;
        return (
          <div>
            <Typography variant="body1">Please enter code</Typography>
            <form onSubmit={this.onCheckCode}>
              <TextField
                disabled={checkingCode}
                value={code}
                onChange={this.handleCodeChange}
                autoFocus={true}
              />
              <br />
              {checkingCode && <LinearProgress />}
              <Button variant="contained" color="primary" type="submit">
                Enter Code
              </Button>
            </form>
          </div>
        );
      }

      private onCheckCode = (e: React.FormEvent) => {
        e.preventDefault();
        this.checkCode();
      };

      private checkCode = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            checkingCode: true,
          },
          {
            checkingCode: undefined,
          },
          async () => {
            const { code } = this.state;
            const { history, responseSource } = this.props;
            if (!code) {
              return;
            }
            // I will check if the code works with the respondent type
            const properAccess = await this.buildGet<IProperAccessCodeResponse>(
              this,
              `check/code/${responseSource}/${code}`
            )();
            console.log(properAccess);
            if (properAccess.properAccessCode) {
              history.push(`/${ResponseSource[responseSource]}/${code}`);
            } else {
              // TODO make this look better
              window.alert(properAccess.errorMessage);
            }
          },
          () => {
            this.setState({ checkingCode: undefined });
            window.alert("something went wrong");
          }
        );

      // add a check code function
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/respondent/EnterCodePage.tsx